import React from "react";
import classNames from "classnames";
import _ from "lodash";
import { WrappedFieldProps } from "redux-form";
import { IntlShape } from "react-intl";
import { Input, FormFeedback } from "reactstrap";

import { Locale } from "@localisation/models";
import { Localisation } from "@localisation/index";
import { FormGroup } from "../FormGroup";
import { DefaultSelect as Select, SelectProps } from "../../Select";

interface FormSelectProps {
    name: string;
    label: string;
    disabled?: boolean;
    id?: string;
    showLabel?: boolean;
    options: any[];
    multiple?: boolean;
    valueKey?: string;
    labelKey?: string;
    intl?: IntlShape;
    locale: Locale;
}

export const FormSelect = (props: WrappedFieldProps & FormSelectProps) => {
    const {
        disabled,
        input,
        name,
        label,
        id,
        showLabel,
        options,
        multiple,
        meta: { error, touched },
        intl,
        locale,
    } = props;
    let { valueKey, labelKey } = props;

    // Sort the group props
    const hasError = touched && error != null;
    const groupProps: any = {
        label,
        showLabel,
        hasError,
    };
    // And the input props.
    const selectProps = {
        name,
    } as SelectProps;
    if (id != null) {
        groupProps.htmlFor = id;
        selectProps.inputId = id;
    }
    // Is multiple
    if (multiple != null && multiple) {
        selectProps.isMulti = true;

        if (input != null && input.value === "") {
            input.value = [];
        }
    }
    else if (input.value === "") {
        input.value = null;
    }

    // Set the default value and display keys.
    if (valueKey == null) {
        valueKey = "id";
    }
    if (labelKey == null) {
        labelKey = "name";
    }

    const selectOptions = options.map((option: any, index: number) => {
        let selectLabel = option[labelKey];
        if (Localisation.instanceOfTranslatableMap(selectLabel)) {
            selectLabel = Localisation.translateMap(selectLabel, locale);
        }
        return {
            value: option[valueKey],
            label: selectLabel,
        };
    });

    // Set the value correctly.
    if (Array.isArray(input.value) && input.value.length > 0 && input.value[0].value == null) {
        input.value = _.map(input.value, (val) => _.find(selectOptions, ["value", val]));
    }
    else if (!Array.isArray(input.value) && input.value != null && input.value.value == null) {
        input.value = _.find(selectOptions, ["value", input.value]);
    }

    return (
        <FormGroup {...groupProps}>
            <Select {...selectProps} {...input}
                className="form-react-select"
                options={selectOptions}
                isDisabled={disabled}
                onBlur={() => {
                    let value: any = input.value;
                    if (Array.isArray(input.value)) {
                        value = input.value.map((val: any) => val.value);
                    }
                    else if (input.value != null && input.value.value != null) {
                        value = input.value.value;
                    }
                    input.onBlur(value);
                }} />
            <Input
                type="hidden"
                valid={hasError ? false : undefined}
                className={classNames({"is-invalid": hasError})}
            />
            {hasError &&
                <FormFeedback>{error}</FormFeedback>
            }
        </FormGroup>
    );
};
